import { z } from 'zod';

// Porovnanie 2-3 firiem vedľa seba (Týž. 19) — najnovší ročný súhrn + rizikové
// skóre pre každú firmu, jedným requestom.
export const companyComparisonSchema = z.object({
  ico: z.string(),
  name: z.string().nullable(),
  city: z.string().nullable(),
  riskScore: z.number().nullable(),
  altmanZScore: z.number().nullable(),
  altmanZone: z.enum(['safe', 'grey', 'distress']).nullable(),
  latestPeriod: z.number().nullable(),
  revenue: z.number().nullable(),
  netIncome: z.number().nullable(),
  equity: z.number().nullable(),
  error: z.string().nullable(),
});
export type CompanyComparison = z.infer<typeof companyComparisonSchema>;
